<template>
  <div class="search">
    <header>
      <form action="/">
        <van-search
          :placeholder="'搜索你要查找的内容'"
          @cancel="cancel"
          @search="search"
          clearable
          maxlength="32"
          show-action
          v-model="searchValue"
        ></van-search>
      </form>
      <!--      v-focus="isShow"-->
      <!--<span @click="cancel">取消</span>-->
    </header>
    <div class="history_list">
      <div
        class="history_item f14"
        v-for="(item, index) in historyList"
        @click.stop="searchHistory(item)"
      >
        <van-icon class="clock_icon" color="#333333" size="0.14rem" name="underway-o" />
        <span>{{ item }}</span>
        <van-icon
          class="close"
          color="#333333"
          size="0.14rem"
          name="cross"
          @click.stop="deleteHistory(index)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { fenxiang, isWeixin } from '@/assets/common/js/config'
export default {
  name: 'beautitySaidSearch',
  data() {
    return {
      searchValue: '',
      historyList: []
    }
  },
  beforeMount() {
    if (
      localStorage.getItem('beautitysaid_historylist') !== null &&
      localStorage.getItem('beautitysaid_historylist') !== undefined &&
      localStorage.getItem('beautitysaid_historylist') !== ''
    ) {
      this.historyList = JSON.parse(localStorage.getItem('beautitysaid_historylist'))
    }
  },
  mounted() {
    if (isWeixin()) fenxiang({ path: 'beautitysearch' })
  },
  methods: {
    cancel() {
      this.$app.argFunc(
        () => {
          this.$router.go(-1)
        },
        () => {
          wx.miniProgram.navigateBack()
        }
      )
    },
    search() {
      if (this.searchValue) {
        this.$clickburiedPoint({
          url: 'ckysdatacenter/searchword/save',
          data: {
            type: 'beautity',
            keyword: this.searchValue
          }
        })
        this.$app.argLink({
          path: '/bsr',
          query: {
            searchval: encodeURIComponent(this.searchValue)
          }
        })
      } else {
        this.$toast('请正确输入查询内容')
      }
    },
    deleteHistory: function(index) {
      this.historyList.splice(index, 1)
      localStorage.setItem('beautitysaid_historylist', JSON.stringify(this.historyList))
    },
    searchHistory: function(item) {
      this.searchValue = item
      this.search()
    }
  }
}
</script>

<style scoped lang="scss">
header {
  background-color: #ffffff;
  padding-left: 0.11rem;
}
.history_list {
  height: calc(100vh - 0.54rem);
  background: #ffffff;
  margin-top: 0.1rem;
  padding: 0.12rem 0.11rem;
}
.history_item {
  position: relative;
  margin-bottom: 0.12rem;
  .clock_icon {
    vertical-align: middle;
  }
  span {
    color: #333333;
  }
}
.close {
  position: absolute;
  right: 0;
  top: 0.03rem;
}
</style>



// WEBPACK FOOTER //
// src/components/community-beautitysaid/search.vue